/**
 * Copyright (c) 2015 ZenPayroll
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from 'react';
import AlwaysMaskedField, { AlwaysMaskedFieldProps } from './AlwaysMaskedField';

type Omit<T, K> = Pick<T, Exclude<keyof T, K>>;

export interface MaskedFieldProps extends Omit<AlwaysMaskedFieldProps, 'mask'> {
  mask?: string;
}

const MaskedField: React.FC<MaskedFieldProps> = ({ mask, ...props }) => {
  if (mask) {
    return <AlwaysMaskedField mask={mask} {...props} />;
  }
  const { translations, onComplete, valueLink, inputRef, ...inputProps } = props;
  return <input {...inputProps} type="text" />;
};

export default MaskedField;
